<template>
  <div class="animated fadeIn">
    <basic-heading title="Results" class="mb-3" />
    <result-server-table />
  </div>
</template>

<script>
  import BasicHeading from "@/components/shared/BasicHeading";
  import ResultServerTable from "@/components/modus/result/ResultServerTable";

  export default {
    name: 'ResultIndex',
    components: {
      ResultServerTable,
      BasicHeading
    },
    data() {
      return {}
    },
    methods: {

    },
    mounted() {

    },
  };
</script>
